import once from '../../../src/js/utils/once.js';

/* global Drupal requestAnimationFrame */

/**
 * Adds an attribute to each field of the form once it has been submitted. Like this the validity of
 * the fields can be visualized, even if they were not yet focused.
 *
 * @param formSelector The selector to obtain the form element(s).
 * @param submitButtonClickedAttribute The attribute name which should be added to the input element
 *                                     once the submitbutton was clicked.
 */
export default function initValidationForSubmittedForms({
    formSelector = '.js-form',
    submitButtonClickedAttribute = 'data-submit-button-has-been-clicked',
} = {}) {
    Drupal.behaviors.submitButtonClickHandler = {
        attach: (context) => {

            const forms = context.querySelectorAll(formSelector);

            for (const form of forms) {
                const inputElements = form.querySelectorAll('input, textarea, select');
                const submitButton = form.querySelector('input[type=submit]');
                if (!submitButton) return;

                once(submitButton, 'submit-button-click-handler', () => {
                    submitButton.addEventListener('click', () => {
                        for (const inputElement of inputElements) {
                            if (inputElement.hasAttribute(submitButtonClickedAttribute)) return;
                            requestAnimationFrame(() => inputElement.setAttribute(submitButtonClickedAttribute, ''));
                        }
                    });
                });

            }

        },
    };
}
